import { JobProgressStatus } from 'constants/JobProgress';
import JobProgressService from 'services/job-progress/JobProgressService';
import { useAsync } from './useAsync';
import useInterval from './useInterval';

const useJobProgress = (requestId, limitNumberRequests, stopRequest) => {
    const [execute, status, data, error] = useAsync(
        JobProgressService.getJobProgress,
        false,
    );
    const isError = status === 'error';
    const isSuccess = status === 'success';
    const [value] = data?.data || [];

    const hasError =
        isError ||
        (isSuccess && value.status === JobProgressStatus.Failed) ||
        stopRequest;
    const isFinished =
        isSuccess &&
        (value?.status === JobProgressStatus.Finished ||
            value?.status === JobProgressStatus.Completed);
    const stop = hasError || isFinished;

    useInterval(
        () => {
            execute(requestId);
            limitNumberRequests();
        },
        stop ? null : 1000,
    );

    return {
        isError: hasError,
        isSuccess,
        isFinished: stop,
        data: value,
        error,
    };
};

export default useJobProgress;
